import React, {useEffect} from "react";
import {useUserContext} from "../../context/UserContextProvider";
import "@cjdev-internal/visual-stack/lib/global";

const Content = ({user, MediaTrackerApp}) => {
    const {setUserData} = useUserContext();

    useEffect(() => {
        setUserData(user);
    }, [user])

    return <MediaTrackerApp/>;
};

export default Content;